import React, { useState } from "react";

import { HelpOutline } from "@mui/icons-material";
import { Typography, styled, tooltipClasses } from "@mui/material";

import ConfirmationModal from "@rui/ConfirmationModal";
import Dropdown, { DropdownMenuItem } from "@rui/Dropdown";
import { getSelectedFromOptions } from "@rui/Dropdown/utils";
import Stack, { Row } from "@rui/Stack";
import TooltipWrapper, { TooltipWrapperProps } from "@rui/TooltipWrapper";

import { WorkspaceSettingConfirmationModalProps } from "./types";

const LargeTooltip = styled(({ className, ...props }: TooltipWrapperProps) => (
  <TooltipWrapper {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 400,
  },
});

const TOOLTIP_CONTENT = (
  <Stack spacing={2}>
    More restrictive options means members can update settings as long as they
    are less permissive than the defaults. <br />
    <br />
    For example, if the default Workspace setting is to have Read ‘join internal
    meetings’ only, members cannot change the setting to join internal and
    external. <br /> <br />
    When you don’t allow changes, members cannot change their settings from the
    Workspace defaults.
  </Stack>
);

const OPTIONS = [
  {
    label: "Yes, only to more restrictive options",
    isDefault: true,
    value: "true",
  },
  {
    label: "No, don't allow changes",
    value: "false",
  },
];
const MemberSettings = (props: WorkspaceSettingConfirmationModalProps) => {
  const [selected, setSelected] = useState(
    props.workspaceSettings.storeRecordingOptInIsUserEditable
  );

  const handleClose = () => {
    setSelected(props.workspaceSettings.storeRecordingOptInIsUserEditable);
    props.onClose();
  };
  const handleConfirm = () => {
    props.onConfirm(selected);
  };

  return (
    <ConfirmationModal
      title="Member settings"
      subtitle="Allow members to update their settings?"
      {...props}
      onClose={handleClose}
      size="md"
      onConfirm={handleConfirm}
    >
      <Dropdown
        name="member-settings"
        selectedItem={getSelectedFromOptions(OPTIONS, `${selected}`)}
        onChange={(e) => setSelected(e.target.value === "true")}
      >
        {OPTIONS.map((op) => (
          <DropdownMenuItem
            key={op.value}
            {...op}
            selected={op.value === `${selected}`}
          />
        ))}
      </Dropdown>
      <LargeTooltip title={TOOLTIP_CONTENT} placement="bottom-start">
        <Row variant="left" spacing={1}>
          <HelpOutline
            sx={{
              ml: 1,
              fontSize: "12px",
              color: "shades.secondary.500",
            }}
          />
          <Typography variant="labelMed" sx={{ color: "shades.secondary.500" }}>
            What's the difference
          </Typography>
        </Row>
      </LargeTooltip>
    </ConfirmationModal>
  );
};

export default MemberSettings;
